import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CadTrainerAndStaff } from '../../../models/cad-trainer-and-staff.model';
import { CourseAccreditationDocumentStorageService } from '../../../services/course-accreditation-document-storage.service';
import * as XLSX from 'xlsx';
import {CadOtherRequirement} from '../../../models/cad-other-requirement.model';
import {UtilityService} from '../../../../../shared/services/utility.service';
import { CourseAccreditationDocumentService } from '../../../services/course-accreditation-document.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-add-cad-trainer-and-staff',
  templateUrl: './add-cad-trainer-and-staff.component.html',
  styleUrls: ['./add-cad-trainer-and-staff.component.scss']
})
export class AddCadTrainerAndStaffComponent implements OnInit {

  @Input() InputData: any;
  isEditMode: boolean = false;
  singleCad: CadTrainerAndStaff;
  onStartSingleCadEdit$: Subscription;
  onEditingSingleCadId!: number | null;
  cadForm: FormGroup;
  editedItem!: any;
  editedItemId!: number;
  cadList: CadTrainerAndStaff[] = [];
  tamMainId: number;
  onCadTrainerAndStaffSubscription$: Subscription;

  // cadForm: FormGroup;
  // tamMainId: string | null;
  excelData: any[] = [];
  userFile: any = File;
  allowedExtensions = '.xlsx,.xls';
  maxFormatFileSize = 3;
  @ViewChild('myInput')
  myInputVariable: ElementRef;
  total: number;
  page = 1;
  size = 10;


  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private cadService: CourseAccreditationDocumentService,
    private cadStorageService: CourseAccreditationDocumentStorageService,
    private notification: NzNotificationService,
    private utilityService: UtilityService
  ) { this.tamMainId = Number(this.route.snapshot.queryParamMap.get('tamMainId'));
  this.onEditingSingleCadId = this.cadService.getEditingSingleCadTrainerAndStaffId();
  this.onStartSingleCadEdit$ =
    this.cadService.onStartCadTrainerAndStaffEditing.subscribe(
      (res: number | null) => {
        this.onEditingSingleCadId = res;
      }
    );
  this.cadList = this.cadService.getCadTrainerAndStaffList(this.tamMainId);
  if (this.cadList.length === 0) {
    this.cadStorageService.readCadTrainerAndStaffListByTamId(this.tamMainId, this.page, this.size).subscribe();
  }
  this.onCadTrainerAndStaffSubscription$ =
    this.cadService.onRefreshCadTrainerAndStaffList.subscribe((res) => {
      this.cadList = res;
    });
  }

  ngOnInit(): void {
    console.log(this.InputData);
    this.createCadForm();
    this.editedItemId = this.InputData;
    this.isEditMode = true;
    this.isEditMode = this.editedItemId !== null;
    this.editedItem = this.cadService.getCadTrainerAndStaffById(this.editedItemId);
    
    this.cadForm.patchValue(this.editedItem);

    // this.createCadForm();
    // this.tamMainId = this.route.snapshot.queryParamMap.get('tamMainId');

  }

  createCadForm() {
    this.cadForm = this.fb.group({
      position: [],
      qualification: [],
      unit: [],
      minQuantityReq: [0, [Validators.pattern("^[0-9]*$")]],
      remark: []
    });
  }

  resetForm(): void {
    this.cadForm.reset();
  }

  submitForm(): void {
    for (const key of Object.keys(this.cadForm.controls)) {
      this.cadForm.controls[key].markAsDirty();
      this.cadForm.controls[key].updateValueAndValidity();
    }
    this.singleCad = this.cadForm.value;
    this.singleCad.tamMainId = Number(this.tamMainId);
    const isFalsy = this.cadService.getNullableFormCheck(this.singleCad, this.tamMainId);
    if (isFalsy) {
      this.notification.error('Error', 'All input blank form submit is not allowed');
      return;
    }
    if (this.editedItemId != null) {
      this.cadStorageService.updateCadTrainerAndStaff(this.singleCad, this.editedItemId).subscribe({
        next: (response) =>
          this.notification.success('Success!', 'Trainer/Staff update successfully'),
        error: (error) => {
          if (error.error.message !== undefined && error.error.message !== null){
             this.notification.error('Failed', error.error.message);
          }else{
               this.notification.error(
            'Failed',
            'Please! provide valid information'
          );
          }
        },
      });
    }else {

    const cadData: CadTrainerAndStaff = this.cadForm.value;

    const isFalsy = this.cadService.getNullableFormCheck(cadData, this.tamMainId);
    if (isFalsy) {
      this.notification.error('Error', 'All input blank form submit is not allowed');
      return;
    }

    if(!this.tamMainId) {
      this.notification.error('Error', 'Training and Assessment Material Id not found');
      return;
    }

    cadData.tamMainId = Number(this.tamMainId);
    cadData.minQuantityReq = Number(cadData.minQuantityReq);

    this.cadStorageService
      .createCadTrainerAndStaff(cadData)
      .subscribe({
        next: (response) => {
          this.notification.success('Success','Added Trainer/Staff data');
        },
        error: (error) =>
          {
          if (error.error.message !== undefined && error.error.message !== null){
             this.notification.error('Failed', error.error.message);
          }else{
               this.notification.error(
            'Failed',
            'Please! provide valid information'
          );
          }
        },
      });
      this.cadForm.reset();
    }
    }

  //#region Excel File Upload And Read Excel Data

  onSelectFile(event: any): void {
    const message = this.utilityService.validateInputFile(
      event.target.files,
      this.allowedExtensions,
      this.maxFormatFileSize
    );
    if (message !== '') {
      this.notification.error('error', message);
      this.myInputVariable.nativeElement.value = '';
      return;
    }
    const file = event.target.files[0];
    this.userFile = file;

    /* wire up file reader */
    const target: DataTransfer = event.target as DataTransfer;
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      console.log(data); // Data will be logged in array format containing objects
      this.excelData = data;
      return data;
    };
  }

  submitExcelData(): void {
    const cadTrainerAndStaffList: CadTrainerAndStaff[] = [];

    if (this.myInputVariable.nativeElement.value == 0) {
      this.notification.error('Failed!', 'Please upload cad trainer and staff excel file');
      return;
    } else {
      for (const item of this.excelData) {
        const cadTrainerAndStaff = new CadTrainerAndStaff();

        cadTrainerAndStaff.position = item.PositionName;
        cadTrainerAndStaff.qualification = item.Qualification;
        cadTrainerAndStaff.unit = item.Unit;
        cadTrainerAndStaff.minQuantityReq = item.MinimumQuantityRequired;
        cadTrainerAndStaff.remark = item.Remarks;
        cadTrainerAndStaff.tamMainId = Number(this.tamMainId);

        cadTrainerAndStaffList.push(cadTrainerAndStaff);

        const existItem = cadTrainerAndStaffList.filter(
          (item) => item.position == cadTrainerAndStaff.position
        );

        for (let item of cadTrainerAndStaffList) {
          let msg = item.position;
          if (isNaN(item.minQuantityReq)) {
            this.notification.error(
              'Failed',
              `Invalid minimum quantity requierment for position, Please correct and reupload!`
            );
            this.myInputVariable.nativeElement.value = '';
            return;
          }
        }

        if (existItem.length > 1) {
          this.notification.error(
            'Failed',
            'Duplicate position name found in Excel, Please check!'
          );
          this.myInputVariable.nativeElement.value = '';
          return;
        }
      }
    }

    //#region Excel duplication value check

    // let existItem = this.excelData.filter(
    //   (item) => item.furnitureName == stpTrainer.furnitureName
    // );
    // if (existItem.length > 1) {
    //   this.notification.error(
    //     'Failed',
    //     'Duplicate Data found in Excel, Please check!'
    //   );
    //   return;
    // }
    this.cadStorageService
      .saveExcelCadTrainerAndStaffData(cadTrainerAndStaffList)
      .subscribe({
        next: (response) => {
          this.notification.success(
            'Success!',
            'Cad Trainer And Staff created successfully'
          );
        },
        error: (error) =>
          this.notification.error(
            'Failed',
            'Please! provide valid information'
          ),
      });

    this.myInputVariable.nativeElement.value = '';
    return;
  }

}
